<app-link
  link="/residential-complex"
  [id]="id"
  [queryParams]="queryParams">
  <ng-content></ng-content>
</app-link>
